import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';

/**
 * Generated class for the SundayRaffleDetailPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-sunday-raffle-detail',
  templateUrl: 'sunday-raffle-detail.html',
})
export class SundayRaffleDetailPage {
  rafflesList = [];

  constructor(public navCtrl: NavController, public navParams: NavParams) {
    this.rafflesList = navParams.get('rafflesList');
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad SundayRaffleDetailPage');
  }

}



// WEBPACK FOOTER //
// ./src/app/lottery/sunday-raffle-detail/sunday-raffle-detail.ts